import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Image } from 'primereact/image';

import functions from 'lib/functions';

const NATIONALITIES = require('jsons/nationalities.json');
const JOB_POSITIONS = require('jsons/job_positions.json');
const EMPLOYER_TYPES = require('jsons/employer_types.json');
const RESPONSIBILITIES = require('jsons/responsibilities.json');

const WorkExperienceProfileBox = (props) => {
  const profile = props.profile;
  return (
    <Card className="work-experience-profile-box mt-2">
      <div className="grid user-detail-user">
        <div className="col-7">
          <div className="text-sm text-400">工作職位</div>
          <div className="text-base">{functions.getObjectValueFromArrayById(JOB_POSITIONS.zh, profile.job_position_id)}&nbsp;</div>
        </div>
        <div className="col-5">
          <div className="text-sm text-400">工作國家</div>
          <div className="text-base">{functions.getObjectValueFromArrayById(NATIONALITIES.zh, profile.work_nationality_id)}&nbsp;</div>
        </div>
        <div className="col-7">
          <div className="text-sm text-400">工作日期</div>
          <div className="text-base">{profile.job_start_date} 至 {profile.job_end_date}</div>
        </div>
        <div className="col-5">
          <div className="text-sm text-400">僱主類型</div>
          <div className="text-base">{functions.getObjectValueFromArrayById(EMPLOYER_TYPES.zh, profile.employer_type_id)}</div>
        </div>
        <div className="col-12">
          <div className="text-sm text-400">職責</div>
          <div className="text-base">{functions.getObjectValuesFromArrayByIds(RESPONSIBILITIES.zh, JSON.parse(profile.responsibility)).map(item => <Tag value={item} className="text-xs mr-1 mt-1"></Tag>)}</div>
        </div>
        <div className="col-3">
          <div className="text-sm text-400">推薦信</div>
          <div className="text-base">{profile.reference_letter?'有':'沒有'}</div>
        </div>
        {profile.reference_letter_file !== '' &&
          <div className="col-9">
            <div className="text-sm text-400">查看推薦信</div>
            <div className="text-base mt-1">
              <Image src={profile.reference_letter_file} alt="Avatar" width="100" height="40" preview imageClassName="border-round border-300 border-1 object-fit-cover" />
            </div>
          </div>
        }
      </div>
    </Card>
  );
};

export default WorkExperienceProfileBox;